/**
 * Per-service Connect RPC feature flag hook.
 * Returns true if the given service should use Connect via sabaody.
 */ import { useFeatureFlag, useFeatureFlagsReady } from '../../contexts/featureFlagContext';
const SERVICE_FLAGS = {
    document: 'grpc_gateway_document',
    authz: 'grpc_gateway_authz',
    rag: 'grpc_gateway_rag',
    etl: 'grpc_gateway_etl',
    projectdata: 'grpc_gateway_projectdata',
    connector: 'grpc_gateway_connector',
    govcon: 'grpc_gateway_govcon',
    sharepoint: 'grpc_gateway_sharepoint'
};
/**
 * Hook that checks if a specific service should use Connect RPC via sabaody.
 * Returns false if the flag doesn't exist or Flipt is unavailable.
 */ export function useConnectEnabled(service) {
    return useFeatureFlag(SERVICE_FLAGS[service]);
}
/**
 * Returns true once feature flags have loaded their initial snapshot.
 * Use this to delay queries until flags are resolved, preventing
 * a REST fetch followed by an immediate Connect refetch.
 */ export function useFlagsReady() {
    return useFeatureFlagsReady();
}
